<template>
    <div class="w-full gap-4 flex flex-column">
        <div class="w-full relative align-items-start text-left">
            <div class="w-full" :class="(screenSize=='sm' || screenSize=='xs') ? 'overflow-scroll' : ''">
                <SelectButton v-model="active_index" :options="tabs" optionLabel="label" optionValue="index" optionDisabled="disabled" dataKey="title" size="small">
                    <template #option="slotProps">
                        <span class="text-sm py-1 white-space-nowrap" :class="(slotProps.option.disabled) ? 'text-400' : 'text-600'">
                            {{ slotProps.option.label[lang_] }}
                        </span>
                    </template>
                </SelectButton>
            </div>
        </div>

        <div v-if="active_index==0 || active_index==1 || active_index==2" class="w-full gap-4 flex flex-column">
            <div class="w-full flex">
                <TransferCreate :mainpage="true" 
                    :currency_receive_first="(currency_receive_first) ? currency_receive_first : 'idr'" 
                    :filterPaySys="filter"
                    @goToRequest="setSlideIndex(3)"
                    @error="transferError"
                    @errorMessage="setErrorMessage" />
            </div> 
            <div class="w-full flex">
                <TransferVideoPopup />
            </div>
        </div>
        <div v-if="active_index==3" class="w-full flex flex-column gap-2">
             <InlineMessage v-if="errorMessage" severity="warn" class="border-round-xl text-sm border-round-xl" icon="pi pi-lightbulb">
                <span class="line-height-2 text-sm xl:text-md lg:text-sm">
                    {{ errorMessage }}
                </span>
            </InlineMessage>
            <TransferRequest :transferError="isTransferError" :errorMessage="errorMessage"/>
        </div>
    </div>
</template>

<script>
import TransferCreate       from '@/components/personal/transfer/Create.vue' 
import TransferRequest      from '@/components/personal/transfer/Request.vue' 
import TransferVideoPopup 	from '@/components/widgets/TransferVideoPopup.vue' 

export default {
    props: ['currency_receive_first'],
    data() {
        return {
            filter: null,
            active_index: 0,
            isTransferError: false,
            errorMessage: '',
            tabs: [
                {
                    "label": {
                        "en": "All",
                        "ru": "Все"
                    },
                    "codes": null,
                    "disabled": false,
                    "index": 0
                },
                {
                    "label": {
                        "en": "Online",
                        "ru": "Онлайн",
                    },
                    "codes": ["card", "stock", "sbp", "swift"],
                    "disabled": false,
                    "index": 1
                },
                {
                    "label": {
                        "en": "Сash",
                        "ru": "Наличные",
                    },
                    "codes": ["atm", "office", "courier"],
                    "disabled": false,
                    "index": 2
                },
                {
                    "label": {
                        "en": "Request",
                        "ru": "Запрос",
                    },
                    "codes": ["request"],
                    "disabled": false,
                    "index": 3
                }
            ],
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru'},
        screenSize() { return this.$store.getters.StateScreenSize },
    },
    methods: {
        transferError(error) {
            this.isTransferError = error
            if(error) {
                this.tabs[0].disabled = true
                this.tabs[1].disabled = true
                this.tabs[2].disabled = true
                this.active_index = 3
            } else {
                this.tabs[0].disabled = false
                this.tabs[1].disabled = false
                this.tabs[2].disabled = false
            }
        },
        setErrorMessage(message) {
            if(message && message == 'Error getting all merchants' && !this.isTransferError) {
                this.active_index = 3
                this.isTransferError = true
                this.errorMessage = this.$t('views.transfer.critical_error')
            }
        },
        setSlideIndex(index) {
            this.active_index = index
            try { window.scrollTo({ top: 0, behavior: 'smooth' }) } catch {}
            try { window.Telegram.WebApp.HapticFeedback.impactOccurred('light') } catch {}
        }
    },
    watch: {
        active_index(index) {
            if(this.tabs[index].disabled) return
            this.filter = (this.tabs[index].codes) ? this.tabs[index].codes : null
            if(this.tabs[index].codes) this.active_index = index
            else this.active_index = 0
        }
    },
    components: {
        TransferCreate,
        TransferVideoPopup,
        TransferRequest
    }
}
</script>
